<template>
  <svg
    v-if="filled"
    :width="size"
    :height="size"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.8333 4H6.16667C5 4 4 5 4 6.16667V21.8333C4 23 5 24 6.16667 24H21.8333C23 24 24 23 24 21.8333V6.16667C24 5 23 4 21.8333 4ZM10.6667 19.8333H8.16667V10.6667H10.6667V19.8333ZM9.41667 9.61C8.61167 9.61 7.95833 8.95167 7.95833 8.14C7.95833 7.32833 8.61167 6.67 9.41667 6.67C10.2217 6.67 10.875 7.32833 10.875 8.14C10.875 8.95167 10.2225 9.61 9.41667 9.61ZM20.6667 19.8333H18.1667V15.1633C18.1667 12.3567 14.8333 12.5692 14.8333 15.1633V19.8333H12.3333V10.6667H14.8333V12.1375C15.9967 9.9825 20.6667 9.82333 20.6667 14.2008V19.8333Z"
      :fill="color"
    />
  </svg>

  <svg
    v-else
    :width="28"
    :height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.5 6.16667C3.5 4.72386 4.72386 3.5 6.16667 3.5H21.8333C23.2761 3.5 24.5 4.72386 24.5 6.16667V21.8333C24.5 23.2761 23.2761 24.5 21.8333 24.5H6.16667C4.72386 24.5 3.5 23.2761 3.5 21.8333V6.16667ZM6.16667 4.5C5.27614 4.5 4.5 5.27614 4.5 6.16667V21.8333C4.5 22.7239 5.27614 23.5 6.16667 23.5H21.8333C22.7239 23.5 23.5 22.7239 23.5 21.8333V6.16667C23.5 5.27614 22.7239 4.5 21.8333 4.5H6.16667Z"
      :fill="color"
    />
    <path d="M8.16832 19.8333H10.6683V10.6666H8.16832V19.8333Z" :fill="color" />
    <path
      d="M7.95999 8.13998C7.95999 8.95165 8.61332 9.60998 9.41832 9.60998C10.2242 9.60998 10.8767 8.95165 10.8767 8.13998C10.8767 7.32832 10.2233 6.66998 9.41832 6.66998C8.61332 6.66998 7.95999 7.32832 7.95999 8.13998Z"
      :fill="color"
    />
    <path
      d="M18.1683 19.8333H20.6683V14.2008C20.6683 9.82332 15.9983 9.98248 14.835 12.1375V10.6666H12.335V19.8333H14.835V15.1633C14.835 12.5691 18.1683 12.3566 18.1683 15.1633V19.8333Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 28
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    filled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
